import React from "react";
import Table from "react-bootstrap/Table";
import { Form } from "react-bootstrap";
import "./ConfirmationOfChanges.css";

interface ConfirmationOfChangesProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const ConfirmationOfChanges: React.FC<ConfirmationOfChangesProps> = ({
  formData,
  setFormData,
}) => {
  const tableHeaders = [
    "Audit Type",
    "Description of Changes",
    "Auditor Name",
  ];

  const handleInputChange = (
    field: keyof any,
    value: string
  ) => {
    setFormData((prevData: any) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return (
    <div className="p-4">
      <Table bordered hover className="audit-details-table">
        <thead>
          <tr>
            {tableHeaders.map((header, index) => (
              <th key={index} className="audit-details-table-header">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Form.Control
                type="text"
                name="Audit_Type__c"
                value={formData.Audit_Type__c || ""}
                onChange={(e) =>
                  handleInputChange("Audit_Type__c", e.target.value)
                }
              />
            </td>
            <td>
              <Form.Control
                type="text"
                name="Description_Of_Changes__c"
                value={formData.Description_Of_Changes__c || ""}
                onChange={(e) =>
                  handleInputChange("Description_Of_Changes__c", e.target.value)
                }
              />
            </td>
            <td>
              <Form.Control
                type="text"
                name="Auditor_Name__c"
                value={formData.Auditor_Name__c || ""}
                onChange={(e) =>
                  handleInputChange("Auditor_Name__c", e.target.value)
                }
              />
            </td>
          </tr>
        </tbody>
      </Table>

      <div className="d-flex justify-content-between">
      </div>
    </div>
  );
};

export default ConfirmationOfChanges;
